import { Building2Icon, ConstructionIcon, DropletsIcon, TrafficConeIcon } from "lucide-react";

export const services = [
  { id: "roadworks", lines: ["Roadworks", "Construction"], icon: TrafficConeIcon },
  { id: "civil", lines: ["Civil Works", "Construction"], icon: ConstructionIcon },
  { id: "water", lines: ["Water & Waste", "Management"], icon: DropletsIcon },
  { id: "building", lines: ["Building & Structural", "Works Construction"], icon: Building2Icon },
];
